import { render, staticRenderFns } from "./RequestDetail.vue?vue&type=template&id=bf595e2c&scoped=true"
import script from "./RequestDetail.vue?vue&type=script&setup=true&lang=ts"
export * from "./RequestDetail.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./RequestDetail.vue?vue&type=style&index=0&id=bf595e2c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf595e2c",
  null
  
)

export default component.exports